"use client";

import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
const navItems = [{
  label: "For Patients",
  href: "#patients"
}, {
  label: "For Providers",
  href: "#providers"
}, {
  label: "How It Works",
  href: "#how"
}, {
  label: "Contact",
  href: "#contact"
}];
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      if (!href) return;
      if (href === "/" || href === "/#") {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
        setMobileMenuOpen(false);
        return;
      }
      if (href.startsWith("#")) {
        const element = document.querySelector(href);
        if (element) {
          e.preventDefault();
          element.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
          setMobileMenuOpen(false);
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className={cn("sticky top-0 z-50 w-full transition-all duration-300", scrolled ? "border-b border-[rgba(2,128,144,0.1)] bg-[rgba(250,250,248,0.92)] backdrop-blur-md" : "border-b border-transparent bg-[#fafaf8]")}>
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 md:px-16">
        <Link to="/#" className="font-serif text-2xl font-bold tracking-tight text-[#028090]">
          Kolay<span className="text-[#0a2540]">Health</span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {navItems.map(item => <Link key={item.label} to={item.href} className="text-sm font-medium text-[#4a5f6b] transition-colors hover:text-[#028090]">
              {item.label}
            </Link>)}

          <Link to="#contact" className="rounded-full bg-[#028090] px-5 py-2.5 text-sm font-semibold text-white transition-all hover:bg-[#0a2540]">
            Get Started
          </Link>
        </nav>

        <button type="button" className="p-2 text-[#0a2540] md:hidden" onClick={() => setMobileMenuOpen(prev => !prev)} aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}>
          {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      <div className={cn("overflow-hidden bg-[#fafaf8] transition-all duration-300 md:hidden", mobileMenuOpen ? "max-h-96 border-t border-[rgba(2,128,144,0.1)]" : "max-h-0")}>
        <div className="flex flex-col gap-5 px-6 py-6">
          {navItems.map(item => <Link key={item.label} to={item.href} className="text-base font-medium text-[#0a2540]" onClick={() => setMobileMenuOpen(false)}>
              {item.label}
            </Link>)}

          <Link to="#contact" className="mt-2 inline-flex w-fit rounded-full bg-[#028090] px-5 py-2.5 text-sm font-semibold text-white" onClick={() => setMobileMenuOpen(false)}>
            Get Started
          </Link>
        </div>
      </div>
    </header>;
}